import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchCandidateSubscriptions, fetchCandidateSubscriptionsHistory, fetchCandidateSubscriptionsPaymentCheck, fetchEmployerSubscriptions, fetchEmployerSubscriptionsHistory, fetchEmployerSubscriptionsPaymentCheck } from "./CandidateSubscriptionsAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchCandidateSubscriptionsAsync = createAsyncThunk(
  "CandidateSubscriptions/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchCandidateSubscriptions();

      const resp = data.response;
      // console.log("data's response", data.response);
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchCandidateSubscriptionsHistoryAsync = createAsyncThunk(
  "CandidateSubscriptionsHistory/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchCandidateSubscriptionsHistory();

      const resp = data.response?.data;
      // console.log("data's response", data.response);
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchCandidateSubscriptionsPaymentCheckAsync = createAsyncThunk(
  "CandidateSubscriptionsPaymentCheck/fetch",
  async (uuid, { rejectWithValue }) => {
    try {
      const data = await fetchCandidateSubscriptionsPaymentCheck(uuid);

      const resp = data.response;
      console.log("data's response", data.response);
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const CandidateSubscriptionsSlice = createSlice({
  name: "CandidateSubscriptions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCandidateSubscriptionsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCandidateSubscriptionsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchCandidateSubscriptionsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(fetchCandidateSubscriptionsHistoryAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCandidateSubscriptionsHistoryAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchCandidateSubscriptionsHistoryAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(fetchCandidateSubscriptionsPaymentCheckAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCandidateSubscriptionsPaymentCheckAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchCandidateSubscriptionsPaymentCheckAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      
  },
});

export const selectCandidateSubscriptions = (state) => state.candidateSubscriptions.data;

export default CandidateSubscriptionsSlice.reducer;
